import * as types from './mutations'

const state = {
    locale: localStorage.getItem('locale') || process.env.VUE_APP_LOCALE,
    locales: ['en', 'th']
}

const mutations = {
    [types.UPDATE] (state, locale)
    {
        state.locale = locale
        localStorage.setItem('locale', locale)
        this._vm.$moment.locale(state.locale)
        this._vm.$i18n.set(state.locale)
    }
}

const actions = {

    init({dispatch})
    {
        dispatch('localeReset')
    },

    localeReset({commit})
    {
        let locale = localStorage.getItem('locale') || ( navigator.language || navigator.userLanguage )
        if (!this._vm.$i18n.localeExists(locale))
        {
            locale = document.documentElement.lang ? document.documentElement.lang : process.env.VUE_APP_LOCALE
        }
        commit(types.UPDATE, locale)
    },

    localeSet({commit}, locale)
    {
        if (this._vm.$i18n.localeExists(locale)) commit(types.UPDATE, locale)
    }

}

const getters = {
    locale: state => state.locale,
    locales: state => state.locales,
}

export default {
    state,
    mutations,
    actions,
    getters,
}
